module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/JGZjyH/tc-custom/9781488096372.jpg?1740525222619",
      "alt": "This image is the cover for the book Escapade"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Escapade\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestseller, a sexy romance about business rivals fighting their powerful attraction to each other.")]), _c('br'), _c('br'), _vm._v("When her father dies, heiress Amanda Todd inherits a nearly bankrupt newspaper that she’s determined to bring back from the dead. But controlling interest lies with mysterious millionaire Joshua Lawson, a man even more stubborn than he is handsome. So she heads off to Josh’s Caribbean estate to show him how she can save the failing business. Sparks fly as Amanda and Josh butt heads; she’s never been so attracted to any man before, let alone one whose support she needs to resurrect her family legacy. And he knows full well how much is riding on this. Can this beauty convince him he’s met his match in business . . . and love?"), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Diana Palmer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The prolific author of more than one hundred books, Diana Palmer got her start as a newspaper reporter. A New York Times bestselling author and voted one of the top ten romance writers in America, she has a gift for telling the most sensual tales with charm and humor. Diana lives with her family in Cornelia, Georgia.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0